import { render, staticRenderFns } from "./order-service.vue?vue&type=template&id=600931cc&scoped=true&"
import script from "./order-service.vue?vue&type=script&lang=js&"
export * from "./order-service.vue?vue&type=script&lang=js&"
import style0 from "./order-service.vue?vue&type=style&index=0&id=600931cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600931cc",
  null
  
)

export default component.exports